import { Box } from '@chakra-ui/react'
import React from 'react'
import { BsChatSquareDotsFill } from 'react-icons/bs'

const Feedback = () => {
    return (
        <Box style={{position: 'fixed', bottom: "35px", right: "35px", transition: "opacity 0.3s"}} _hover={{opacity: "0.8"}}>
            <a id="feedback-button" href="/feedback" title="Feedback">
                <svg width="34pt" height="34pt" viewBox="0 -1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: "#50684B", borderRadius: "50%", padding: "7px" }}>
                    <g stroke-width="0"></g>
                    <g stroke-linecap="round" stroke-linejoin="round"></g>
                    <g>
                        <path d="M17 2H7C4.24 2 2 4.23 2 6.98V12.96V13.96C2 16.71 4.24 18.94 7 18.94H8.5C8.77 18.94 9.13 19.12 9.3 19.34L10.8 21.33C11.46 22.21 12.54 22.21 13.2 21.33L14.7 19.34C14.89 19.09 15.19 18.94 15.5 18.94H17C19.76 18.94 22 16.71 22 13.96V6.98C22 4.23 19.76 2 17 2ZM8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12ZM12 12C11.44 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.56 12 12 12ZM16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z" fill="white"></path>
                    </g>
                </svg>
            </a>
            {/* <BsChatSquareDotsFill /> */}
        </Box>
    )
}

export default Feedback